import { render, staticRenderFns } from "./tagConfiguration.vue?vue&type=template&id=90e5ec78&scoped=true"
import script from "./tagConfiguration.vue?vue&type=script&lang=js"
export * from "./tagConfiguration.vue?vue&type=script&lang=js"
import style0 from "./tagConfiguration.vue?vue&type=style&index=0&id=90e5ec78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e5ec78",
  null
  
)

export default component.exports